import { Link } from "@quintype/components";
import React, { useEffect, useState } from "react";
import { string } from "prop-types";

import { fontVariation, printStory } from "./utils";
import ShareAllTemplate from "./share-all-template";
import { SvgIconHandler } from "../../../../../atoms/svg-icon-hadler";

import "./social-share-template.m.css";

export const SocialShareTemplate = (props) => {
  const [elements, setElements] = useState(null);
  const [showPopup, setPopup] = useState(null);

  useEffect(() => {
    const paraElements = document.getElementsByTagName("P");
    const anchorElements = document.getElementsByTagName("A");
    const h1Elements = document.getElementsByTagName("H1");
    const h2Elements = document.getElementsByTagName("H2");
    const h3Elements = document.getElementsByTagName("H3");
    const h6Elements = document.getElementsByTagName("H6");
    const spanElements = document.getElementsByTagName("SPAN");
    const figCaptionElements = document.getElementsByTagName("FIGCAPTION");
    const blockQuoteElements = document.getElementsByTagName("BLOCKQUOTE");
    const divElements = document.getElementsByTagName("DIV");

    Array.from(h6Elements).map((item) => console.log(typeof item));
    const htmlElements = Array.from(paraElements).concat(
      Array.from(anchorElements),
      Array.from(h1Elements),
      Array.from(h2Elements),
      Array.from(h3Elements),
      Array.from(h6Elements),
      Array.from(spanElements),
      Array.from(figCaptionElements),
      Array.from(blockQuoteElements),
      Array.from(divElements)
    );
    setElements(htmlElements);
  }, []);

  return (
    <div styleName="wrapper" className="social-share-template-wrapper">
      <Link href={props.fbUrl} target="_blank" rel="noopener noreferrer" aria-label="facebook">
        <SvgIconHandler type="black-fb" width="10" height="17" viewBox="0 0 10 17" />
      </Link>

      <Link href={props.twitterUrl} target="_blank" rel="noopener noreferrer" aria-label="twitter">
        <SvgIconHandler type="black-twitter" width="24" height="24" viewBox="0 0 24 24" />
      </Link>

      <Link href={props.whatsappUrl} target="_blank" rel="noopener noreferrer" aria-label="whatsapp">
        <SvgIconHandler type="black-whatsapp" width="24" height="24" viewBox="0 0 24 24" />
      </Link>

      <button aria-label="share-all-button" styleName="button">
        <span onClick={() => setPopup(!showPopup)}>
          <SvgIconHandler type="black-share" width="24" height="24" viewBox="0 0 24 24" />
        </span>
        {showPopup && <ShareAllTemplate setPopup={setPopup} {...props} />}
      </button>

      <button aria-label="zoom-in-button" styleName="button" onClick={() => fontVariation("zoom-in", elements)}>
        <SvgIconHandler type="black-zoom-in" width="24" height="24" viewBox="0 0 24 24" />
      </button>

      <button aria-label="zoom-out-button" styleName="button" onClick={() => fontVariation("zoom-out", elements)}>
        <SvgIconHandler type="black-zoom-out" width="24" height="24" viewBox="0 0 24 24" />
      </button>

      <button aria-label="print-button" styleName="button" onClick={printStory}>
        <SvgIconHandler type="black-print" width="24" height="24" viewBox="0 0 24 24" />
      </button>
    </div>
  );
};

SocialShareTemplate.propTypes = {
  fbUrl: string,
  twitterUrl: string,
  whatsappUrl: string,
  fullUrl: string,
};
